import { SchemaEventDefinition } from './SchemaDefinition'
import { EventDefinition } from './TypedDefinition'
import { EventNode } from './TypedNode'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface EventPluginProps extends PluginVisitors {
  preBuildMockParameters?: boolean
}

export class EventPlugin implements RehajePlugin {
  props: EventPluginProps

  visitors: PluginVisitors
  constructor(props?: EventPluginProps) {
    this.props = { ...props }
    this.visitors = {
      definitions: {
        Event: EventDefinition,
        'Schema.Event': SchemaEventDefinition,
        ...this.props.definitions
      },
      nodes: {
        Event: EventNode,
        ...this.props.nodes
      }
    }
  }
}
